import {useDispatch} from 'react-redux';
import {bindActionsToDispatch} from 'Utils';

const useBindingActionsToDispatch = (actions) => {
    const dispatch = useDispatch();
    return bindActionsToDispatch(actions, dispatch);
};

export default useBindingActionsToDispatch;
